import { SceneGraphNode } from 'src/app/engine/models/scene-graph.model';
import { UIConfigModel } from 'src/app/story/models/ui-config.model';

// Instructs loader what to do on load complete
export class StoryAnimationModel {
  scrub?: { time: number };
  play?: {
    startChapterId?: string;
    startTime?: number;
    finishChapterId?: string;
    finishTime?: number;
    numChapters?: number;
  };
}
import { CameraModel } from '../../engine/models/camera.model';
import { Type } from 'class-transformer';
import { TweenParticleLookupModel } from './tween-particle-lookup.model';
import { QuizSettingsModel } from 'src/app/quiz/models/quiz-settings.model';

export class AssetLibrary {
  lights: string[];
  tweens: string[];
  reflections: string[];
}

export class StoryModel {
  // Types -----------------------------------------------------
  @Type(() => SceneGraphNode)
  @Type(() => CameraModel)
  @Type(() => UIConfigModel)

  // Model -----------------------------------------------------
  moduleId: string; // Just "id"
  displayName: string;
  description: string;
  camera: CameraModel;
  chapters: any[];
  stateId: string[];
  assetLibraries: AssetLibrary;
  sceneGraph: SceneGraphNode[];
  ui: UIConfigModel;
  animation: StoryAnimationModel;
  tags: string[];
  customData: any; // playground for experimental data
  reflections: { [key: string]: string }; // shortcut ids for use in materials.
  colorRecipes: any;
  tweenParticleLookup: TweenParticleLookupModel;
  showObjects?: any;
  selectObjects?: any;
  pickThroughObjects?: any;
  synchronization?: any;
  quizSettings?: QuizSettingsModel;

  // images
  thumbnails?: {
    large: string;
    small: string;
  };
}
